module.exports = __webpack_public_path__ + "img/manAndDog.1c24f9e9.svg";